// ============================================================================
// view.webform — the direct Pig Dailys form, off App's boot document
// ============================================================================
// /webform-pigs rendered from one boot-owned value: the ppp-webforms-v1 admin
// document, taken straight off WebformsConfigContext by the presenter. It
// decides which optional fields are `required` at submit time and which carry
// an asterisk. webform.pigDailys.config owns that read now, in this surface's
// own authenticated scope, which is what lets `webform` retire from the frozen
// app_store consumer list in tests/fixtures/former-eager-dependencies.json.
//
// The read is performed by PigDailysAuthenticatedBridge and injected as a prop,
// for the same reason the active-groups lookup is: PigDailysWebform lives in
// src/webforms and must not choose an authenticated Query scope. Two static
// guards hold that line — public_webforms_boundary_static and
// pig_dailys_active_groups_owner_static.
//
// WHY THE ACTIVE-GROUPS LOOKUP IS NOT A SECOND OBLIGATION.
//
// It is not a route resource and it never was one of App's boot values. App's
// /webform-pigs sidecar was retired earlier into `usePigDailysActiveGroups`, a
// component-scoped Query owner beside the bridge, and
// tests/static/pig_dailys_active_groups_owner_static.test.js asserts by name
// that its id must NOT become a catalog resource or a surface obligation. It
// sits where useSavedViewsData and useUserDirectory sit: a shared, already-local
// owner, outside this surface's ownership ledger.
//
// WHY residualLegacy IS EMPTY.
//
// The surface has its own released route and no global data gate. `residualLegacy`
// records values a surface still CONSUMES from an App-owned context; nothing on
// this page reads one, so there is nothing to declare.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.webform',
  obligations: Object.freeze([Object.freeze({id: 'webform.pigDailys.config', owner: 'permanent'})]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
